import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AgRendererComponent } from "ag-grid-angular";
import { Contact } from "../claimscreendetail.component";

@Component({
    template: `
  <select style="width: 100%;" (change)="onClaimantChange($event)" [(ngModel)]="reserveClaimant">
      <option *ngFor="let reserveClaimant of reserveClaimants" [ngValue]="reserveClaimant">{{reserveClaimant.desc}}</option>
    </select>
          `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReserveClaimantRendererComponent implements AgRendererComponent {
  params: any;
  reserveClaimants:Array<Object>;
  reserveClaimant:any;
  agInit(params: any): void {
    this.params = params;
    this.reserveClaimants = params.data.reserveClaimants;
    //console.log('Ag Grid: ' + JSON.stringify(this.params.data, this.getCircularReplacer()));
  }

  onClaimantChange(event){
    const rowIndex = this.params.node.rowIndex;
    let claimReserve = this.params.context.componentParent.claimReserves[rowIndex];
    if(claimReserve !== undefined){
      claimReserve.claimantContact = {};
      claimReserve.claimantContact = {contactId: this.reserveClaimant.id, contactType: this.reserveClaimant.type} ;
    }
    else{
      this.params.context.componentParent.claimReserves[rowIndex] = {};
      this.params.context.componentParent.claimReserves[rowIndex].claimantContact = {};
      this.params.context.componentParent.claimReserves[rowIndex].claimantContact = {contactId: this.reserveClaimant.id, contactType: this.reserveClaimant.type};
    }
    console.log('parent grid: ' + JSON.stringify(this.params.context.componentParent.claimReserves,  this.getCircularReplacer())); 
  }

  refresh(params: any): boolean {
    
    return false;
  }

  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };
}
